var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconSuccessFilled24 = function SvgAIconSuccessFilled24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#48B078"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.304 7.69531L10.3987 15.6329C10.2641 15.814 10.0581 15.9273 9.8342 15.9433C9.61029 15.9594 9.39049 15.8767 9.23177 15.7167L7.69531 14.1678",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconSuccessFilled24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTIiIGZpbGw9IiM0OEIwNzgiLz4KPHBhdGggZD0iTTE2LjMwNCA3LjY5NTMxTDEwLjM5ODcgMTUuNjMyOUMxMC4yNjQxIDE1LjgxNCAxMC4wNTgxIDE1LjkyNzMgOS44MzQyIDE1Ljk0MzNDOS42MTAyOSAxNS45NTk0IDkuMzkwNDkgMTUuODc2NyA5LjIzMTc3IDE1LjcxNjdMNy42OTUzMSAxNC4xNjc4IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";